import type { RacePhase } from '@runkr/schema'

/**
 * How long the matchmaking screen stays over the race at the start of the countdown (PHASE3
 * T3.2): long enough for the bots to drop onto the empty pedestals and "Get ready!" to read,
 * short enough that the race intro's 3-2-1 (T3.3) is visible from the "3".
 */
export const HANDOFF_MS = 300

/** What the matchmaking layer over the race screen shows: itself, "Loading…", or nothing. */
export type HandoffView = 'handoff' | 'loading' | null

/**
 * The race screen takes over on the first `countdown` state (flow.ts). Until the race scene is
 * built (`Session.raceReady`) the pedestals stay up with "Loading…" so no blank canvas shows;
 * once built they stay for `HANDOFF_MS` into the countdown, then the race shows. Once hidden it
 * never comes back for that race (`dismissed`). Pure, so the hand-off is unit-tested.
 */
export function handoffView(o: {
  phase: RacePhase | null
  sinceMs: number
  raceReady: boolean
  dismissed: boolean
}): HandoffView {
  if (o.dismissed) return null
  if (!o.raceReady) return 'loading'
  if (o.phase === 'countdown' && o.sinceMs < HANDOFF_MS) return 'handoff'
  return null
}
